import './ScrollTop.scss';

import { FC, useEffect, useState } from 'react';

const ScrollTop: FC = () => {
  const [isActiveScrollTopBtn, setIsActiveScrollBtn] = useState<boolean>(false);

  useEffect(() => {
    const setActiveScrollTopBtn = () => (window.scrollY > 0 ? setIsActiveScrollBtn(true) : setIsActiveScrollBtn(false));

    window.addEventListener('scroll', setActiveScrollTopBtn);

    setActiveScrollTopBtn();

    return () => window.removeEventListener('scroll', setActiveScrollTopBtn);
  }, []);

  const handleScrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className={['scroll-top', isActiveScrollTopBtn ? 'active' : ''].join(' ')} onClick={handleScrollToTop}>
      <svg
        data-slot='icon'
        fill='none'
        strokeWidth='1.5'
        stroke='currentColor'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
        className='w-6 h-6 mb-1'
      >
        <path strokeLinecap='round' strokeLinejoin='round' d='m4.5 15.75 7.5-7.5 7.5 7.5'></path>
      </svg>
    </div>
  );
};

export default ScrollTop;
